import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo, useMemo } from 'react';
import { FilterSection } from '../../components/filter-section';
import { useFilterSections } from '../../hooks/use-filter-sections';
import { GroupChildrenFilter } from '../group-children-filter';
import type { GroupWrapperFilterProps as Props } from './types';

export const GroupWrapperFilter = memo(({ className, ...filter }: Props) => {
  const selectKeys = useMemo(
    () => filter.items?.map((i) => i.field!).filter(Boolean) ?? [],
    [filter.items]
  );
  const { getParam } = useSearchQueryFilter({ select: selectKeys });
  const { mainItems, moreItems } = useFilterSections(filter, filter.sections);

  const isAnyOfMoreItemsSet = useMemo(() => {
    return moreItems?.map((i) => getParam(i.field!)).filter(Boolean);
  }, [moreItems, getParam]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      className={classnames('GroupWrapperFilter', className)}
    >
      {mainItems?.map(({ key, ...item }) => {
        return <GroupChildrenFilter key={key} open {...item} />;
      })}
      {moreItems?.length ? (
        <FilterSection
          open={!!isAnyOfMoreItemsSet?.length}
          title="More Filters"
        >
          {moreItems?.map(({ key, ...item }) => {
            return <GroupChildrenFilter key={key} open {...item} />;
          })}
        </FilterSection>
      ) : null}
    </Box>
  );
});

GroupWrapperFilter.displayName = 'GroupWrapperFilter';
